import { useQuery } from '@tanstack/react-query';

import { getMe } from './api';
import { queryKeys } from './queryKeys';

/**
 * The ONLY source of session state in the client. The cookie is httpOnly — JavaScript
 * cannot read it and must not try — so who you are is discovered by asking the server and
 * nothing else. Every caller shares one query key, so the whole app asks once.
 */
export function useSession() {
  return useQuery({ queryKey: queryKeys.me, queryFn: getMe, retry: false });
}
